import { Info } from "@mui/icons-material"
import { Grid, IconProps, SvgIconTypeMap, useTheme } from "@mui/material"
import { OverridableComponent } from "@mui/material/OverridableComponent"
import { HtmlTooltip } from "../HtmlTooltip/HtmlTooltip"
import { useStyles } from "./styles"

interface DetailsTooltipProps extends IconProps {
    details: { label: string; value?: string }[]
    disabled: boolean
    label: string
    animate?: boolean
    Icon?: OverridableComponent<SvgIconTypeMap> & { muiName: string }
}

export const DetailsTooltip = ({ animate, className, details, disabled, Icon = Info, label }: DetailsTooltipProps) => {
    const { classes, cx } = useStyles()
    const theme = useTheme()

    const body = (
        <Grid container direction={"column"} columnSpacing={2}>
            {details.map((detail) => (
                <Grid container item spacing={2} key={detail.label} sx={{ justifyContent: "space-between" }}>
                    <Grid item sx={{ color: theme.palette.grey[700], fontWeight: 400 }}>
                        {detail.label}
                    </Grid>
                    <Grid item>{detail.value}</Grid>
                </Grid>
            ))}
        </Grid>
    )

    return (
        <span className={className}>
            <HtmlTooltip title={label} body={body} disabled={disabled}>
                <Icon
                    color={disabled ? "disabled" : "primary"}
                    className={cx(classes.icon, { [classes.bounce]: !disabled && animate })}
                />
            </HtmlTooltip>
        </span>
    )
}
